import { Fragment } from "react";

import "./logolist.scss";

import Link from "../link/link";
import Icon from "../icon/icon";

function Logolist(props) {
  return (
    <Fragment>
      {props.title && <div className="logo-list__title">{props.title}</div>}
      <div className={`logo-list ${props.brands ? "logo-list-brands" : ""}`}>
        {props.items &&
          props.items.map((element, index) => (
            <Link
              href={element.href}
              className={`logo-list__item${
                props.grid ? ` logo-list__item--grid-${props.grid}` : ""
              }`}
              key={`${props.id ? props.id : "item"}-${index}`}
              ariaLabel={`link zu ${element.name}`}
            >
              <Icon
                name={element.icon}
                className={`logo-list__logo${
                  props.inProgress ? " logo-list__logo--in-progress" : ""
                }${props.maxHeight ? " logo-list__logo--max-height" : ""}${
                  props.imageClass ? ` ${props.imageClass}` : ""
                }`}
                renderImgTag={element.renderImgTag}
              />
              {element.name && (
                <span className="logo-list__name">{element.name}</span>
              )}
              {props.inProgress && (
                <img
                  className="logo-list__loading-indicator"
                  src="/images/loading.svg"
                  alt="loading icon"
                  loading="lazy"
                />
              )}
            </Link>
          ))}
      </div>
    </Fragment>
  );
}

export default Logolist;
